module.exports = __webpack_public_path__ + "img/Firelord Ozai-256.ac74464d.png";